module.exports = __webpack_public_path__ + "img/pm.85556bea.svg";